import { ComponentType, forwardRef } from 'react';

import { Pressable as NbPressable } from 'native-base';

import { addWithConfig } from '../../utils';

import type { PressableProps } from './types';

const getDirectStringChild = (children: PressableProps['children']) =>
  typeof children === 'string' ? children : undefined;

const getDatadogActionName = ({ accessibilityLabel, children, ...props }: PressableProps) =>
  props['dd-action-name'] ||
  accessibilityLabel ||
  props['aria-label'] ||
  getDirectStringChild(children);

export const Pressable = (forwardRef((props: PressableProps, ref: any) => {
  const { children } = props;

  return (
    <NbPressable {...props} dd-action-name={getDatadogActionName(props)} ref={ref}>
      {children}
    </NbPressable>
  );
}) as unknown) as ComponentType<PressableProps>;

export default addWithConfig(Pressable);
